import { render, staticRenderFns } from "./frescobaldi.vue?vue&type=template&id=02f81caf&scoped=true"
import script from "./frescobaldi.vue?vue&type=script&lang=js"
export * from "./frescobaldi.vue?vue&type=script&lang=js"
import style0 from "./frescobaldi.vue?vue&type=style&index=0&id=02f81caf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f81caf",
  null
  
)

export default component.exports